import React from "react";
import { Link } from "react-router-dom";


export default function Actionbutton({to, text, background='bg-light-pink', outline='primary', fontsize='text-sm/6', vertpadding='py-3', horzpadding='px-8', textcolor='text-primary'}) {
    return(
        <Link to={to} className={`inline-flex items-center rounded-full ${background} ${vertpadding} ${horzpadding} ${fontsize} font-semibold  ${textcolor} ${outline && `outline ${outline}`} outline-1`}>
             {text}
       </Link>

    )
}